import Header from './components/Header';
import Hero from './components/Hero';
import FeaturesSection from './components/FeaturesSection';
import CardsSection from './components/CardsSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import TopicsSection from './components/TopicsSection';
import FAQSection from './components/FAQSection';
import AboutSection from './components/AboutSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import IndexSection from './components/IndexSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <FeaturesSection />
        <CardsSection />
        <ContactSection />
        <CarouselSection />
        <UpdatesSection />
        <AppSection />
        <RankingSection />
        <TopicsSection />
        <FAQSection />
        <AboutSection />
        <CommentsSection />
        <MediaSection />
        <IndexSection />
      </main>
      <Footer />
    </>
  );
}